import Text from '@components/Text';
import Button from '@components/_Revamp/Button';
import Input from '@components/_Revamp/Input';
import { css } from '@linaria/core';
import { styled } from '@linaria/react'
import { useAvivaSelector } from '@redux/hook';
import { GAAviva } from '@utils/gaAvivaR3';
import React, { useCallback, useEffect, useState } from 'react'
import Lottie from 'react-lottie-player';
import { themeDefault } from 'src/theme-revamp';
import { PromoMessageBox } from './PromoMessageBox';
import failedAnimation from '@assets/images/sl-animate-failed.json';
import successAnimation from '@assets/images/sl-animate-success.json';

const Container = styled.div`
    display: block;
`;
const FormContentContainer = styled.div`
    margin: 64px auto 0;
    display: flex;
    flex-wrap: wrap;
    justify-content:center;
    @media screen and (max-width: 768px) {
    }
`;
const FormHeaderContainer = styled.div`
    display: block;

`;

const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
    display: block;
    margin: 0 ${props => props.marginHorizontal};
    margin-bottom:16px;
    @media screen and (max-width: 768px) {
      padding: 0 0px;
      margin-bottom:16px;
    }
`;
const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0 50px;
  @media screen and (max-width: 768px) {
    margin: 0;
    padding: 0;
  }
`;


const HeaderTitleCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  text-align: center;
  color: #434343;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;


const HeaderDescriptionCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: #8A8988;
  @media screen and (max-width: 768px) {
    font-weight: 400;
  }
`;


export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}
export interface PromoCodeContentProps {
  onChange?: (e: any) => void;
  validatePromoCode?: (promoCode: any) => void;
  validateNric?: (nric: any) => void;
  show?: boolean | undefined;
  promoCodeStatus?: string | undefined;
  nricRequired?: boolean;
  isApplied?: boolean;
  value?: string;
  promoMsgCode?: string;
  nricMsgCode?: string;
}


function PromoCodeContent({ onChange, validatePromoCode, validateNric, show, promoCodeStatus, promoMsgCode = "", nricMsgCode = "", value = "", isApplied = false, nricRequired = false }: PromoCodeContentProps) {

  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [promoCode, setPromoCode] = useState("");
  const [nric, setNric] = useState("");
  const [innerPromoCodeStatus, setInnerPromoCodeStatus] = useState(promoCodeStatus);
  const [innerPromoCode, setInnerPromoCode] = useState(promoCode);
  const [innerNricRequired, setInnerNricRequired] = useState(nricRequired);
  const promoPercentage = useAvivaSelector(state => state.mltcR3Step2.promoPercentage);
  const sqsQuotation = useAvivaSelector(state=>state.mltcR3Step2.sqsQuotation);
  
  const trackOnPromoCode = useCallback(() => {
    const GA = GAAviva.getInstance();
    let { acquisition } = GA.digitalData;
    acquisition.insurance.promocode = promoCode;
    GA.trackPageLoad({ acquisition });
  },[promoCode]);


  useEffect(() => {
    //Reset Promocode when modal open
    if (promoCode !== "" && !isLoaded) {
      setIsLoaded(true);
      // setPromoCode("");
    }
    setInnerPromoCodeStatus("");
    if (promoCode && (promoCodeStatus === "success" || promoCodeStatus === "invalid")) {
      trackOnPromoCode();
      setInnerPromoCodeStatus(promoCodeStatus);
      setInnerPromoCode(promoCode)
    }
    
    setInnerNricRequired(nricRequired);
  }, [show, promoCodeStatus, promoCode, nricRequired, isLoaded, trackOnPromoCode]);

  
  if (promoCodeStatus === "error") {
    return (
      <Container>
        <FormHeaderContainer>
          <FormHeaderTitleContainer marginHorizontal={"0px"}>
            <Lottie loop={false} animationData={failedAnimation} play={true} style={{ margin: "auto", width: 150, height: 150 }}></Lottie>
          </FormHeaderTitleContainer>
          <FormHeaderTitleContainer marginHorizontal={"0px"}>
            <Text theme={themeDefault} className={HeaderTitleCss}>
              Opps, Something wrong
            </Text>
          </FormHeaderTitleContainer>
          <FormHeaderDescriptionContainer>
            <Text theme={themeDefault} className={HeaderDescriptionCss}>
              Please try again
            </Text>
          </FormHeaderDescriptionContainer>
        </FormHeaderContainer>
      </Container>
    )
  }
  else if (promoCodeStatus === "invalid") {
    return (
      <Container>
        <FormHeaderContainer>
          <FormHeaderTitleContainer marginHorizontal={"0px"}>
            <Lottie loop={false} animationData={failedAnimation} play={true} style={{ margin: "auto", width: 150, height: 150 }}></Lottie>
          </FormHeaderTitleContainer>
          <FormHeaderTitleContainer marginHorizontal={"0px"}>
            <Text theme={themeDefault} className={HeaderTitleCss}>
              Invalid Promo Code
            </Text>
          </FormHeaderTitleContainer>
          <FormHeaderDescriptionContainer>
            <Text theme={themeDefault} className={HeaderDescriptionCss}>
              Please check that you keyed in the correct promo code
            </Text>
          </FormHeaderDescriptionContainer>
        </FormHeaderContainer>
      </Container>
    )
  }
  else if (promoCodeStatus === "success") {
    return (
      <Container>
        <FormHeaderContainer>
          <FormHeaderTitleContainer marginHorizontal={"0px"}>
            <Lottie loop={false} animationData={successAnimation} play={true} style={{ margin: "auto", width: 150, height: 150 }}></Lottie>
          </FormHeaderTitleContainer>
          <FormHeaderTitleContainer marginHorizontal={"0px"}>
            <Text theme={themeDefault} className={HeaderTitleCss}>
              Promo code has been successfully applied
            </Text>
          </FormHeaderTitleContainer>
          <FormHeaderDescriptionContainer>
            <Text theme={themeDefault} className={HeaderDescriptionCss}>
            {sqsQuotation?.firstYearDiscountEligible 
              ? `You are eligible to additional ${sqsQuotation.totalFirstYearDiscount}% off your first year premium,
              on top of the ${sqsQuotation.totalPerpetualDiscount}% off perpetual discount`
              : `You are eligible to ${promoPercentage && `${promoPercentage}%`} off this purchase.` 
            }
            </Text>
          </FormHeaderDescriptionContainer>
        </FormHeaderContainer>
      </Container>
    )
  }
  else if (promoCodeStatus === "invalidNric") {
    return (
      <Container>
        <FormHeaderContainer>
          <FormHeaderTitleContainer marginHorizontal={"0px"}>
            <Lottie loop={false} animationData={failedAnimation} play={true} style={{ margin: "auto", width: 150, height: 150 }}></Lottie>
          </FormHeaderTitleContainer>
          <FormHeaderTitleContainer marginHorizontal={"0px"}>
            <Text theme={themeDefault} className={HeaderTitleCss}>
              Your NRIC is not eligible for the promo code
            </Text>
          </FormHeaderTitleContainer>
          <FormHeaderDescriptionContainer>
            <Text theme={themeDefault} className={HeaderDescriptionCss}>
              Please check that you keyed in the correct NRIC number
            </Text>
          </FormHeaderDescriptionContainer>
        </FormHeaderContainer>
      </Container>
    )
  }
  else {
    return (
      <React.Fragment>
        <Container>
          <FormHeaderContainer>
            <FormHeaderTitleContainer marginHorizontal={"0px"}>
              <Text theme={themeDefault} className={HeaderTitleCss}>
                Key in your Promo Code
              </Text>
            </FormHeaderTitleContainer>
            <FormHeaderDescriptionContainer>
              <Text theme={themeDefault} className={HeaderDescriptionCss}>
                Good to know that you have a better offer!
              </Text>
            </FormHeaderDescriptionContainer>
          </FormHeaderContainer>
          <PromoMessageBox type={promoMsgCode}/>
          <FormContentContainer>
            <Input name={"promoCode"} variant={"default"} textAlign={"center"} value={value} onChange={(e) => {
              setPromoCode(e.target.value);
              if(innerPromoCodeStatus !== "success")
              {
                setInnerPromoCodeStatus("");
              }
              if (onChange) {
                onChange(e);
              }
            }}></Input>
            {!innerNricRequired && <Button disabled={value === ""} onClick={() => validatePromoCode ? validatePromoCode(promoCode) : ""} width={"180px"} variant={'default'} theme={themeDefault} label={"Save"}></Button>}
          </FormContentContainer>
        </Container>
       {innerNricRequired && <Container>
          <FormHeaderContainer>
            <FormHeaderTitleContainer marginHorizontal={"0px"}>
              <Text theme={themeDefault} className={HeaderTitleCss}>
               Verify with your NRIC number
              </Text>
            </FormHeaderTitleContainer>
            <FormHeaderDescriptionContainer>
              <Text theme={themeDefault} className={HeaderDescriptionCss}>
                Verify with your NRIC number
              </Text>
            </FormHeaderDescriptionContainer>
          </FormHeaderContainer>
          <PromoMessageBox type={nricMsgCode}/>
          <FormContentContainer>
            <Input name={"promoNric"} variant={"default"} textAlign={"center"} value={nric} onChange={(e) => {
              setNric(e.target.value);
              if (onChange) {
                onChange(e);
              }
            }}></Input>
            <Button disabled={nric === ""} onClick={() => validateNric ? validateNric(nric) : ""} width={"180px"} variant={'default'} theme={themeDefault} label={"Let's Go"}></Button>
          </FormContentContainer>
        </Container>}
      </React.Fragment>
    )
  }
}

export default PromoCodeContent